import { AuthMessageType, ClientType, ConnectionMessage, ConnectionMessageType, websocket } from '@playcastdotio/Messaging';
import { authState } from '../../../stores/shared';
import { attachSentryTraceToMessage } from '../../realtime/tracing';

export const handleConnectionMessage = async (message: ConnectionMessage, rawSocket: WebSocket | null) => {
  console.log('Connection message:', message);
  const accessToken = authState.currentState.accessToken;

  switch (message.type) {
    case ConnectionMessageType.CONN_AUTH_REQUIRED: {
      console.log('Auth required');
      const msg = websocket.generators.auth(AuthMessageType.AUTH_REQUEST, {
        clientType: ClientType.REMOTE_CLIENT,
        tokenJwt: accessToken,
      });
      // Bypass ready check
      attachSentryTraceToMessage(msg);
      rawSocket?.send(JSON.stringify(msg));
    }
  }
};

